export function formatSsn(rawValue) {
    if (!rawValue) return '';
    var value = "".concat(rawValue);
    if (value.match(/^\d{3}-\d{2}-\d{4}$/)) {
        return value;
    }
    var digits = value.replace(/[^0-9]/g, '');
    return "".concat(digits.substring(0, 3), "-").concat(digits.substring(3, 5), "-").concat(digits.substring(5, 9));
}

//# sourceMappingURL=formatSsn.js.map